import { useState, useEffect } from "react";
import "./App.css";
import AboutMe from "./components/AboutMe/AboutMe";
import Contact from "./components/Contact/Contact";
import DesktopOnlySite from "./components/DesktopOnlySite";
import Header from "./components/Header/Header";
import LandingSection from "./components/LandingSection/LandingSection";
import Services from "./components/Services/Services";
import Particles from "./components/Particles/Particles";
import ProjectsPopup from "./components/ProjectsPopup/ProjectsPopup";
import ProjectsPage from "./components/ProjectsPage/ProjectsPage";

function App() {
  const [currentPage, setCurrentPage] = useState("home");
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [direction, setDirection] = useState("forward");

  useEffect(() => {
    // Simple routing based on URL path
    const path = window.location.pathname;
    if (path === "/projects") {
      setCurrentPage("projects");
    } else {
      setCurrentPage("home");
    }

    // Handle browser back/forward
    const handlePopState = () => {
      setIsTransitioning(true);
      setDirection("backward");
      const path = window.location.pathname;
      setTimeout(() => {
        if (path === "/projects") {
          setCurrentPage("projects");
        } else {
          setCurrentPage("home");
        }
        setTimeout(() => setIsTransitioning(false), 50);
      }, 300);
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  const handleNavigateToProjects = () => {
    setIsTransitioning(true);
    setDirection("forward");
    setTimeout(() => {
      window.history.pushState({}, "", "/projects");
      setCurrentPage("projects");
      setTimeout(() => setIsTransitioning(false), 50);
    }, 300);
  };

  if (currentPage === "projects") {
    return (
      <div className={`page-transition ${isTransitioning ? "transitioning-out" : direction === "forward" ? "slide-in-from-right" : "transitioning-in"}`}>
        <ProjectsPage />
      </div>
    );
  }

  return (
    <>
      <div className={`page-transition ${isTransitioning ? "transitioning-out" : "transitioning-in"}`}>
        <Particles />
        <div className="container">
          <Header />
          <LandingSection />
          <AboutMe />
          <Services />
          <Contact />

          <img
            className="crystal-about"
            src="src/assets/crystal-stone.png"
            alt="crystal stone"
          />
        </div>
        <DesktopOnlySite />
      </div>
      <ProjectsPopup onNavigate={handleNavigateToProjects} />
    </>
  );
}

export default App;
